<template lang="html">
  <div class="v-main" v-if="show">
    <div class="name">
      {{message.Al140}}
      <i class="close material-icons" @click="show=false" v-if="!app.versionCheck">
        close
      </i>
    </div>
    <div class="box">
      <div class="cell other">
         <i class="el-icon-warning "></i>
         <span v-if="info.appVersion !== '---'" class="info">
           {{message.Al141}}
         </span>
         <span v-if="info.appVersion === '---'" class="info">
           {{message.Al142}}
         </span>
      </div>
      <div class="cell">
        <div class="title">
          {{message.Al143}}：
        </div>
        <span class="version">
          {{ info.appVersion }}
        </span>
      </div>
      <div class="cell">
        <div class="title">
          {{message.Al144}}：
        </div>
        <span class="version">
          {{ info.newVersion }}
        </span>
      </div>
      <div class="cell" style="text-align:center">
        <el-button type="primary" @click="downloadAssist">
          <a  class="download">{{message.Al145}}</a>
        </el-button>
          <div class="line">
            {{message.Al178.l0}}
            <span @click="reset">{{message.Al178.l1}}</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      app: 'app'
    })
  },
  watch: {
    'app.info.appVersion': function () {
      var ver = this._global.arrayToInt(this.app.info.appVersion)
      var newVer = this._global.arrayToInt(this.app.info.newVersion)
      if (this.app.versionCheck || ver < newVer) {
        this.show = true
        this.info.appVersion = this.app.info.appVersion
        this.info.newVersion = this.app.info.newVersion
        this.info.downloadUrl = this.app.info.downloadUrl
      } else {
        this.show = false
      }
    }
  },
  data () {
    return {
      message: {
        Al140: this.$lang.ui.app.l140,
        Al141: this.$lang.ui.app.l141,
        Al142: this.$lang.ui.app.l142,
        Al143: this.$lang.ui.app.l143,
        Al144: this.$lang.ui.app.l144,
        Al145: this.$lang.ui.app.l145,
        Al178: this.$lang.ui.app.l178
      },
      show: false,
      info: {
        appVersion: '-',
        newVersion: '-',
        downloadUrl: ''
      }
    }
  },
  methods: {
    downloadAssist () {
      window.open(this.info.downloadUrl)
    },
    reset () {
      window.location.reload()
    }
  }
}
</script>

<style lang="css" scoped>
.v-main {
  z-index: 10000;
  position: fixed;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  overflow: hidden;
  margin-left: -200px;
  margin-top: -130px;
  top: 42%;
  left: 50%;
  width: 400px;
  height: auto;
  border-radius: 8px;
  background-color: #fff;
  font-size: 14px;
}
.name {
  position: relative;
  font-weight: 600;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: #0291cf;
}
.name span {
  position: absolute;
  top: 0;
  right: 18px;
  height: 100%;
  display: block;
  color: #fff;
  float: right;
  font-size: 21px;
  cursor: pointer;
}
.name span:hover {
  font-size: 25px;
}
.box {
  width: 100%;
  padding: 14px 45px;
}
.cell {
  width: 100%;
  padding: 12px 0;
  overflow: hidden;
  text-align: left;
}
.cell i {
  float: left;
  width: 15%;
  font-size: 36px;
  color: #f7ba2a;
}
.cell .info {
  float: right;
  display: block;
  width: 85%;
}
.title {
  font-weight: 600;
  padding-left: 5px;
  display: inline-block;
}
.version {
  display: inline-block;
  width: auto;
}
.download {
  color: #fff;
  text-decoration: none;
}
.close {
  cursor: pointer;
  float: right;
  margin: 4px 4px 0 0;
}
.line {
  margin-top: 15px;
}
.line span {
  cursor: pointer;
  color: #007bc5;
}
.line span:hover {
  text-decoration: underline;
}
</style>
